import redirectToStore from './redirect-to-store';

export default {
  redirectToStore,
};
